// font-resets.ts
import { A } from "@adornis/base/env-info";
import "@adornis/base/utilTypes";
import { ChemistryLiteElement } from "@adornis/chemistry/chemistry-lite-element";
import { css } from "@adornis/chemistry/directives/css";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes";
import "@adornis/writer/x-plain-writer";
import { html, noChange } from "lit";
import { BehaviorSubject, combineLatest } from "rxjs";
import { filter } from "rxjs/operators";
var el;
function ensurePreconnectToGoogleFonts() {
  return;
  if (!el) {
    el = document.createElement("link");
    el.rel = "preconnect";
    el.href = "https://fonts.gstatic.com";
    document.head.appendChild(el);
  }
}
var fontData = {
  "aviano sans": {
    googleFont: false,
    capHeightRatio: 0.816,
    descenderHeightRatio: 0.12,
    900: { capHeightRatio: 0.63, descenderHeightRatio: 0.22 },
    100: { capHeightRatio: 0.756, descenderHeightRatio: 0.17 }
  },
  "proxima nova": {
    googleFont: false,
    capHeightRatio: 1.026,
    descenderHeightRatio: 0.04,
    900: { capHeightRatio: 0.73, descenderHeightRatio: 0.12 },
    500: { capHeightRatio: 0.75, descenderHeightRatio: 0.12 },
    800: { capHeightRatio: 0.73, descenderHeightRatio: 0.13 },
    600: { capHeightRatio: 0.73, descenderHeightRatio: 0.13 },
    700: { capHeightRatio: 0.73, descenderHeightRatio: 0.13 },
    100: { capHeightRatio: 0.756, descenderHeightRatio: 0.17 }
  },
  grotesk: {
    googleFont: false,
    capHeightRatio: 0.73,
    descenderHeightRatio: 0.1605,
    900: { capHeightRatio: 0.76, descenderHeightRatio: 0.143 }
  },
  "apercu-mono": {
    googleFont: false,
    capHeightRatio: 0.95,
    descenderHeightRatio: 0.01,
    900: { capHeightRatio: 0.63, descenderHeightRatio: 0.22 },
    500: { capHeightRatio: 0.63, descenderHeightRatio: 0.22 },
    100: { capHeightRatio: 0.756, descenderHeightRatio: 0.17 }
  },
  "circular std": {
    googleFont: false,
    capHeightRatio: 0.816,
    descenderHeightRatio: 0.12,
    900: { capHeightRatio: 0.63, descenderHeightRatio: 0.22 }
  },
  avenir: {
    googleFont: false,
    capHeightRatio: 0.816,
    descenderHeightRatio: 0.12,
    900: { capHeightRatio: 0.63, descenderHeightRatio: 0.22 },
    100: { capHeightRatio: 0.756, descenderHeightRatio: 0.17 }
  },
  "maven pro": { googleFont: true, capHeightRatio: 0.788 - 0.123, descenderHeightRatio: 0.123 },
  lato: {
    googleFont: true,
    capHeightRatio: 0.828 - 0.112,
    descenderHeightRatio: 0.112,
    900: { descenderHeightRatio: 0.097, capHeightRatio: 0.844 - 0.097 }
  },
  "open sans": { googleFont: true, capHeightRatio: 0.84 - 0.112, descenderHeightRatio: 0.112 },
  kalam: { googleFont: true, capHeightRatio: 0, descenderHeightRatio: 0.23 },
  barlow: { googleFont: true, capHeightRatio: 0.15, descenderHeightRatio: 0.21 },
  gotham: {
    capHeightRatio: 0.71,
    descenderHeightRatio: 0.125,
    700: { descenderHeightRatio: 0.128, capHeightRatio: 0.703 }
  },
  montserrat: { capHeightRatio: 0.84, descenderHeightRatio: 0.1, googleFont: true },
  "noto sans": { capHeightRatio: 0.1, descenderHeightRatio: 0.2, googleFont: true },
  "work sans": { googleFont: true, capHeightRatio: 0.68, descenderHeightRatio: 0.165 },
  whitney: { capHeightRatio: 0, descenderHeightRatio: 0 },
  raleway: { googleFont: true, capHeightRatio: 0, descenderHeightRatio: 0 },
  roboto: { googleFont: true, capHeightRatio: 0, descenderHeightRatio: 0 },
  poppins: {
    googleFont: true,
    capHeightRatio: 0.842 - 0.15,
    descenderHeightRatio: 0.15,
    900: { capHeightRatio: 0.857 - 0.15, descenderHeightRatio: 0.15 }
  },
  "amatic sc": { googleFont: true, capHeightRatio: 0.863 - 0.115, descenderHeightRatio: 0.115 },
  helvetica: {
    googleFont: false,
    capHeightRatio: 0.841 - 0.153,
    descenderHeightRatio: 0.153,
    900: { capHeightRatio: 0.841 - 0.153, descenderHeightRatio: 0.153 },
    700: { capHeightRatio: 0.868 - 0.154, descenderHeightRatio: 0.154 }
  },
  "ubuntu mono": {
    googleFont: true,
    capHeightRatio: 0.83 - 0.17,
    descenderHeightRatio: 0.17
  },
  "neue-haas-grotesk": {
    googleFont: false,
    capHeightRatio: 0.73,
    descenderHeightRatio: 0.1605,
    900: { capHeightRatio: 0.76, descenderHeightRatio: 0.143 }
  },
  "ibm plex sans": {
    googleFont: true,
    descenderHeightRatio: 0.124,
    capHeightRatio: 0.821,
    700: {
      descenderHeightRatio: 0.124,
      capHeightRatio: 0.863
    }
  },
  kta: { googleFont: false, capHeightRatio: 0.695, descenderHeightRatio: 0.205 },
  "sf-ui-text": { googleFont: false, descenderHeightRatio: 0.135, capHeightRatio: 0.731 },
  "sf-ui-display": { googleFont: false, descenderHeightRatio: 0.135, capHeightRatio: 0.721 },
  abeezee: { capHeightRatio: 0.869, descenderHeightRatio: 0.161, googleFont: true }
};
var embeddedFontSheets = /* @__PURE__ */ new Map();
function ensureFontSheet(link) {
  if (!embeddedFontSheets.has(link)) {
    const el2 = document.createElement("link");
    el2.href = link;
    el2.rel = "stylesheet";
    embeddedFontSheets.set(link, el2);
    document.head.appendChild(el2);
  }
}
var addFont = (name, sheet, data) => {
  ensureFontSheet(sheet);
  if (fontData[name])
    console.warn(`Overwriting fontData for font "${name}"`);
  fontData[name] = data;
};
var fontReset = (fontFamily = "monospace", fontSizeModifier = 1, weight = 400, lineHeightModifier = 1.13, baseFontSize = 16) => {
  const normalizedFontFamily = fontFamily.split(",")[0];
  let data = fontData[normalizedFontFamily.toLowerCase().replace(/'/g, "")];
  if (data?.googleFont) {
    ensurePreconnectToGoogleFonts();
    const link = A.absoluteUrl("/__fonts/google/api") + `/css2?family=${normalizedFontFamily.replace(/ /g, "+").replace(/'/g, "")}${weight && weight !== 400 ? `:wght@${weight}` : ""}&display=swap`;
    ensureFontSheet(link);
  }
  if (data?.[weight])
    data = data[weight];
  if (!data) {
    console.warn(`using default font reset for '${fontFamily}', fonts wont be pretty :/`);
    data = { descenderHeightRatio: 0, capHeightRatio: 1 };
  }
  if (!data.capHeightRatio)
    data.capHeightRatio = 1 - 2 * data.descenderHeightRatio;
  const fontSize = fontSizeModifier * baseFontSize;
  const lineHeight = lineHeightModifier * fontSize;
  const topSpace = (1 - data.capHeightRatio - data.descenderHeightRatio) * fontSize + (lineHeight - fontSize) / 2;
  const bottomSpace = data.descenderHeightRatio * fontSize + (lineHeight - fontSize) / 2;
  return {
    fontFamily,
    fontWeight: `${weight}`,
    fontSize: fontSize + "px",
    lineHeight: lineHeight + "px",
    "&:before": {
      content: '""',
      display: "block",
      height: "0",
      marginTop: `-${topSpace}px`
    },
    "&:after": {
      content: '""',
      display: "block",
      height: "0",
      marginBottom: `-${bottomSpace}px`
    },
    "&[ellipsis]": { minWidth: "0" },
    "&[blurred]": { filter: "blur(6px)" }
  };
};
var FontResetElement = class extends ChemistryLiteElement {
  constructor() {
    super();
    this._value = new BehaviorSubject("");
    this._disabled = new BehaviorSubject(true);
    this._error = new BehaviorSubject("");
    this.renderTarget = null;
    if (this.disabled)
      this.setAttribute("disabled", "");
    this.ensureRenderTargetIfNecessary();
  }
  get value() {
    return this._value.getValue();
  }
  set value(val) {
    this._value.next(val);
  }
  get disabled() {
    return this._disabled.getValue();
  }
  set disabled(val) {
    this._disabled.next(val);
  }
  get error() {
    return this._error.getValue();
  }
  set error(val) {
    this._error.next(val);
  }
  connectedCallback() {
    super.connectedCallback();
    this._subscription = combineLatest([this._value, this._disabled]).pipe(filter(([_, disabled]) => !disabled || this.hasAttribute("ellipsis"))).subscribe(([value]) => {
      this.dispatchEvent(new CustomEvent(`value-changed`, { detail: { value } }));
      this.rerender();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this._subscription?.unsubscribe();
  }
  render() {
    if (!this.hasAttribute("disabled")) {
      import("@adornis/writer/x-writer");
      return html`
        <x-plain-writer
          .useHTML="${false}"
          .commands=${this.commands}
          .value=${this.value}
          @value-changed=${(e) => e.detail.value !== this.value && (this.value = e.detail.value)}
          ${injectAttributesOf(this, ["disabled"])}
        >
        </x-plain-writer>
      `;
    }
    if (this.hasAttribute("ellipsis")) {
      return html`
        <div ${css({ minWidth: "0", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" })}>
          ${this.value}
        </div>
      `;
    }
    return noChange;
  }
  static get observedAttributes() {
    return ["ellipsis", "disabled", "value"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue)
      return;
    if (name === "disabled")
      this.disabled = newValue === "";
    if (name === "value" && typeof newValue === "string")
      this.value = newValue || "";
    if (name === "disabled" || name === "ellipsis")
      this.ensureRenderTargetIfNecessary();
    this.rerender();
  }
  ensureRenderTargetIfNecessary() {
    if ((this.hasAttribute("ellipsis") || !this.hasAttribute("disabled")) && !this.renderTarget)
      this.renderTarget = this.attachShadow({ mode: "open" });
  }
};
export {
  FontResetElement,
  addFont,
  fontReset
};
